import React, {Component} from 'react';
import QuickMenu from './QuickMenu';
import {NavLink} from 'react-router-dom';
import './SideNavBar.scss';

export class SideNavBar extends Component {
  renderSubmenus = submenus => (
    <ul className="page-side__submenus">
      {submenus.map((submenu, idx) => (
        <li key={idx}>
          <NavLink to={submenu.path}>{submenu.name}</NavLink>
        </li>
      ))}
    </ul>
  );

  render() {
    return (
      <div className="page-side">
        <h1 className="page-side__title">{this.props.title}</h1>
        <div className="page-side__menus">
          {this.props.menus.map((menu, idx) => (
            <div key={idx} className="page-side__menu-block">
              <NavLink className="page-side__menu" to={menu.path}>
                {menu.name}
              </NavLink>
              {menu.submenus && this.renderSubmenus(menu.submenus)}
            </div>
          ))}
        </div>
        <QuickMenu />
      </div>
    );
  }
}

export default SideNavBar;
